<template>
  <!-- 用户管理-用户箱子领取记录 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="箱子领取记录"
      width="800px"
      @close="closeDialog"
    >
      <!-- header头部 -->
      <header>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="箱子id">
            <el-input size="small" v-model="formData.box_id"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="getData"
              >搜索
            </el-button>
          </el-form-item>
        </el-form>
      </header>
      <!-- body内容 -->
      <div class="body-box">
        <el-table
          :data="dataList"
          v-loading="loading"
          style="margin-bottom: 20px"
        >
          <el-table-column prop="box_id" label="箱子id" align="center">
          </el-table-column>
          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="{ row }">
              <el-tag type="danger" v-if="row.status == 1">已使用</el-tag>
              <el-tag type="success" v-else>未使用</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="获取时间" align="center">
          </el-table-column>
          <el-table-column prop="updated_at" label="使用时间" align="center">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'

export default {
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    type: {//类型
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      lock: false,//加锁
      formData: {
        box_id: ''
      },
      dataList: undefined,//数据列表
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    dialogData: {
      get() {
        return this.value
      },
      set() {
      }
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
      }
    },
  },
  created() {
  },
  methods: {
    getData() {
      this.loading = true
      let params = this.formData
      getApiData(`user_giving_box/${this.dialogData.id}`, params).then((res) => {
        this.dataList = res
      }).finally(() => {
        this.loading = false
      })
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
</style>